import { z } from 'zod';
/**
 * Catálogo curado de íconos Lucide React relevantes para un pasaporte de evento
 * académico/científico. Los valores son nombres exactos de íconos de
 * lucide-react y pueden mapearse en el frontend con un import dinámico o un
 * registro estático.
 */
export const PASSPORT_ICONS = [
    'Microscope',
    'Dna',
    'FlaskConical',
    'Beaker',
    'Atom',
    'Brain',
    'Lightbulb',
    'Users',
    'GraduationCap',
    'BookOpen',
    'Presentation',
    'Mic2',
    'Award',
    'Trophy',
    'Star',
    'Store',
    'MapPin',
    'Camera',
    'Share2',
    'MessageCircle',
    'HelpCircle',
    'Puzzle',
    'HeartHandshake',
    'Coffee',
    'UtensilsCrossed',
    'Gift',
    'Heart',
    'Sparkles',
    'Calendar',
    'Clock',
    'Flag',
    'Target',
    'Zap',
    'Compass',
    'Globe2',
];
export const PassportIconSchema = z.enum(PASSPORT_ICONS);
export function parsePassportIcon(raw) {
    if (!raw)
        return null;
    const result = PassportIconSchema.safeParse(raw);
    return result.success ? result.data : null;
}
//# sourceMappingURL=passport-icons.js.map